import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/54351995/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { HeroLayout } from '@primer/gatsby-theme-doctocat';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = HeroLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`Text can be `}<strong parentName="p">{`bold`}</strong>{`, `}<em parentName="p">{`italic`}</em>{`, or `}<del parentName="p">{`strikethrough`}</del>{`. `}<a parentName="p" {...{
        "href": "https://github.com"
      }}>{`Links`}</a>{` should be blue with no underlines (unless hovered over).`}</p>
    <p>{`There should be whitespace between paragraphs. There should be whitespace between paragraphs. There should be whitespace between paragraphs. There should be whitespace between paragraphs.`}</p>
    <p>{`There should be whitespace between paragraphs. There should be whitespace between paragraphs. There should be whitespace between paragraphs. There should be whitespace between paragraphs.`}</p>
    <blockquote>
      <p parentName="blockquote">{`There should be no margin above this first sentence.`}</p>
      <p parentName="blockquote">{`Blockquotes should be a lighter gray with a gray border along the left side.`}</p>
      <p parentName="blockquote">{`There should be no margin below this final sentence.`}</p>
    </blockquote>
    <h1>{`Header 1`}</h1>
    <p>{`This is a normal paragraph following a header. Bacon ipsum dolor sit amet t-bone doner shank drumstick, pork belly porchetta chuck sausage brisket ham hock rump pig. Chuck kielbasa leberkas, pork bresaola ham hock filet mignon cow shoulder short ribs biltong.`}</p>
    <h2>{`Header 2`}</h2>
    <blockquote>
      <p parentName="blockquote">{`This is a blockquote following a header. Bacon ipsum dolor sit amet t-bone doner shank drumstick, pork belly porchetta chuck sausage brisket ham hock rump pig. Chuck kielbasa leberkas, pork bresaola ham hock filet mignon cow shoulder short ribs biltong.`}</p>
    </blockquote>
    <h3>{`Header 3`}</h3>
    <pre><code parentName="pre" {...{}}>{`This is a code block following a header.
`}</code></pre>
    <h4>{`Header 4`}</h4>
    <ul>
      <li parentName="ul">{`This is an unordered list following a header.`}</li>
      <li parentName="ul">{`This is an unordered list following a header.`}</li>
      <li parentName="ul">{`This is an unordered list following a header.`}</li>
    </ul>
    <h5>{`Header 5`}</h5>
    <ol>
      <li parentName="ol">{`This is an ordered list following a header.`}</li>
      <li parentName="ol">{`This is an ordered list following a header.`}</li>
      <li parentName="ol">{`This is an ordered list following a header.`}</li>
    </ol>
    <h6>{`Header 6`}</h6>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Follows`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`A table`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A header`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`A table`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A header`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`A table`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A header`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <p>{`There's a horizontal rule above and below this.`}</p>
    <hr></hr>
    <p>{`Here is an unordered list:`}</p>
    <ul>
      <li parentName="ul">{`Salt-n-Pepa`}</li>
      <li parentName="ul">{`Bel Biv DeVoe`}</li>
      <li parentName="ul">{`Kid 'N Play`}</li>
    </ul>
    <p>{`And an ordered list:`}</p>
    <ol>
      <li parentName="ol">{`Michael Jackson`}</li>
      <li parentName="ol">{`Michael Bolton`}</li>
      <li parentName="ol">{`Michael Bublé`}</li>
    </ol>
    <p>{`And an unordered task list:`}</p>
    <ul {...{
      "className": "contains-task-list"
    }}>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`Create a sample markdown document`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`Add task lists to it`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Take a vacation`}</li>
    </ul>
    <p>{`And a "mixed" task list:`}</p>
    <ul {...{
      "className": "contains-task-list"
    }}>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Steal underpants`}</li>
      <li parentName="ul">{`?`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Profit!`}</li>
    </ul>
    <p>{`And a nested list:`}</p>
    <ul>
      <li parentName="ul">{`Jackson 5`}<ul parentName="li">
          <li parentName="ul">{`Michael`}</li>
          <li parentName="ul">{`Tito`}</li>
          <li parentName="ul">{`Jackie`}</li>
          <li parentName="ul">{`Marlon`}</li>
          <li parentName="ul">{`Jermaine`}</li>
        </ul></li>
      <li parentName="ul">{`TMNT`}<ul parentName="li">
          <li parentName="ul">{`Leonardo`}</li>
          <li parentName="ul">{`Michelangelo`}</li>
          <li parentName="ul">{`Donatello`}</li>
          <li parentName="ul">{`Raphael`}</li>
        </ul></li>
    </ul>
    <p>{`Definition lists can be used with HTML syntax. Definition terms are bold and italic.`}</p>
    <dl>
  <dt>Name</dt>
  <dd>Godzilla</dd>
  <dt>Born</dt>
  <dd>1952</dd>
  <dt>Birthplace</dt>
  <dd>Japan</dd>
  <dt>Color</dt>
  <dd>Green</dd>
    </dl>
    <hr></hr>
    <p>{`Tables should have bold headings and alternating shaded rows.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Artist`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Album`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Year`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Michael Jackson`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Thriller`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1982`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Prince`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Purple Rain`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1984`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Beastie Boys`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`License to Ill`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1986`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`If a table is too wide, it should condense down and/or scroll horizontally.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Artist`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Album`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Year`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Label`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Awards`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Songs`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Michael Jackson`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Thriller`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1982`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Epic Records`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Grammy Award for Album of the Year, American Music Award for Favorite Pop/Rock Album, American Music Award for Favorite Soul/R&B Album, Brit Award for Best Selling Album, Grammy Award for Best Engineered Album, Non-Classical`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wanna Be Startin' Somethin', Baby Be Mine, The Girl Is Mine, Thriller, Beat It, Billie Jean, Human Nature, P.Y.T. (Pretty Young Thing), The Lady in My Life`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Prince`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Purple Rain`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1984`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Warner Brothers Records`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Grammy Award for Best Score Soundtrack for Visual Media, American Music Award for Favorite Pop/Rock Album, American Music Award for Favorite Soul/R&B Album, Brit Award for Best Soundtrack/Cast Recording, Grammy Award for Best Rock Performance by a Duo or Group with Vocal`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Let's Go Crazy, Take Me With U, The Beautiful Ones, Computer Blue, Darling Nikki, When Doves Cry, I Would Die 4 U, Baby I'm a Star, Purple Rain`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Beastie Boys`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`License to Ill`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1986`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mercury Records`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`noawardsbutthistablecelliswide`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rhymin & Stealin, The New Style, She's Crafty, Posse in Effect, Slow Ride, Girls, (You Gotta) Fight for Your Right, No Sleep Till Brooklyn, Paul Revere, Hold It Now, Hit It, Brass Monkey, Slow and Low, Time to Get Ill`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <p>{`Code snippets like `}<inlineCode parentName="p">{`var foo = "bar";`}</inlineCode>{` can be shown inline.`}</p>
    <p>{`Also, `}<inlineCode parentName="p">{`this should vertically align`}</inlineCode>{` `}<del parentName="p"><inlineCode parentName="del">{`with this`}</inlineCode></del>{` `}<del parentName="p">{`and this`}</del>{`.`}</p>
    <p>{`Code can also be shown in a block element.`}</p>
    <pre><code parentName="pre" {...{}}>{`var foo = "bar";
`}</code></pre>
    <p>{`Code can also use syntax highlighting.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var foo = 'bar'
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`Long, single-line code blocks should not wrap. They should horizontally scroll if they are too long. This line should be long enough to demonstrate this.
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var foo =
  'The same thing is true for code with syntax highlighting. A single line of code should horizontally scroll if it is really long.'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<div>Live example</div>
`}</code></pre>
    <p>{`Inline code inside table cells should still be distinguishable.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Language`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Code`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Javascript`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`var foo = "bar";`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ruby`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`foo = "bar"`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <p>{`Small images should be shown at their actual size.`}</p>
    <p><img parentName="p" {...{
        "src": "http://placekitten.com/g/300/200/",
        "alt": null
      }}></img></p>
    <p>{`Large images should always scale down and fit in the content container.`}</p>
    <p><img parentName="p" {...{
        "src": "http://placekitten.com/g/1200/800/",
        "alt": null
      }}></img></p>
    <pre><code parentName="pre" {...{}}>{`This is the final element on the page and there should be no margin below this.
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      